import * as React from 'react';

import type { SkillTag } from '@coursera/grpc-types-skills/coursera/proto/skills/tags/v2/skill_tag';

import EnterpriseLearningPathBreadcrumbsModuleRenderer from 'bundles/enterprise-learning-path-description-page/module-renderer/EnterpriseLearningPathBreadcrumbsModuleRenderer';
import EnterpriseLearningPathProductOverviewModuleRenderer from 'bundles/enterprise-learning-path-description-page/module-renderer/EnterpriseLearningPathProductOverviewModuleRenderer';
import EnterpriseLearningPathSyllabusModuleRenderer from 'bundles/enterprise-learning-path-description-page/module-renderer/EnterpriseLearningPathSyllabusModuleRenderer';
import EnterpriseOrgScopedLearningPathBreadcrumbsModuleRenderer from 'bundles/enterprise-learning-path-description-page/module-renderer/EnterpriseOrgScopedLearningPathBreadcrumbsModuleRenderer';
import type { EnterpriseLearningPathPageFieldsFragment } from 'bundles/enterprise-learning-path-description-page/queries/__generated__/EnterpriseLearningPathPageFragments';
import { useIsOrgScopedHome } from 'bundles/unified-common/hooks/useIsOrgScopedHome';
import { ModuleNames, type PageConfig } from 'bundles/unified-description-page-common/types/moduleConfig';

type Props = {
  productTitle: string;
  pageData: EnterpriseLearningPathPageFieldsFragment;
  skillTagsData: Record<string, SkillTag[]>;
  pageConfig?: PageConfig | null;
};

const Renderer = ({ productTitle, pageData, skillTagsData, pageConfig }: Props) => {
  const isOrgScopedHome = useIsOrgScopedHome();

  if (!pageConfig || !pageConfig.modules.length || !skillTagsData) {
    return null;
  }

  const modulesToRender = pageConfig.modules.map((moduleConfig) => {
    switch (moduleConfig.name) {
      case ModuleNames.ProductOverview:
        return <EnterpriseLearningPathProductOverviewModuleRenderer productTitle={productTitle} pageData={pageData} />;
      case ModuleNames.Breadcrumbs:
        return isOrgScopedHome ? (
          <EnterpriseOrgScopedLearningPathBreadcrumbsModuleRenderer pageData={pageData} />
        ) : (
          <EnterpriseLearningPathBreadcrumbsModuleRenderer pageData={pageData} />
        );
      case ModuleNames.Syllabus:
        return <EnterpriseLearningPathSyllabusModuleRenderer pageData={pageData} skillTagsData={skillTagsData} />;
      default:
        return null;
    }
  });
  return <>{modulesToRender}</>;
};

export default Renderer;
